import { DeploymentGroup, DeploymentGroupMember } from '@/types/deploymentGroup'

export const formatRate = (value: number | null) =>
  value === null ? '-' : String(Number(value.toFixed(1)))

export const getMemberRate = (
  group: DeploymentGroup,
  member: DeploymentGroupMember
) => {
  const stored = group.metrics?.members?.[member.deployment_id]

  return {
    fps: member.fps ?? stored?.fps ?? null,
    source_fps: member.source_fps ?? stored?.source_fps ?? null
  }
}
